module.exports = __webpack_public_path__ + "media/images/icon/ico_top_flow05-b2596a2499ebf3749af313508509eadc.svg";